//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import QfPaddingMarginSize from "../properties/padding-margin-size/qf-padding-margin-size.vue";
import QfPAlignment from "../properties/alignment/qf-p-alignment.vue";
import QfPDisplay from "../properties/display/qf-p-display.vue";
import ComponentsUtils from "../mixins/components-utils";

import QfPSizing from "../properties/sizing/qf-p-sizing.vue";

export default {
    name: "QfComponentProperties",
    components: {
        QfPSizing, QfPDisplay, QfPAlignment, QfPaddingMarginSize
    },
    mixins: [ComponentsUtils],
    provide() {
        const component = {};
        component.addSlot = this.addSlot;
        component.utils = {
            getDocumentTemplates: this.__getDocumentTemplates,
            getMappingAttributes: this.__getMappingAttributes,
            generateCode: this.__generateCode,
            getColorValue: this.__getColorValue
        };
        Object.defineProperty(component, "properties", { enumerable: true, get: () => this.activeProperties });
        Object.defineProperty(component, "language", { enumerable: true, get: () => this.userData.language });
        Object.defineProperty(component, "bodyReference", { enumerable: true, get: () => this.bodyReference });
        Object.defineProperty(component, "activeComponent", { enumerable: true, get: () => this.activeComponent });

        if (this.data && this.data.hasOwnProperty(this.activeComponent)) {
            Object.defineProperty(component, "data", { enumerable: true, get: () => this.data[this.activeComponent] });
        }

        // if (config.slots) {
        //     Object.defineProperty(component, "slots", { enumerable: true, get: () => this.slots });
        // }
        return { component };
    },
    data() {
        return {
            thumbStyle: {
                right: "-5px", borderRadius: "2px", width: "4px", opacity: 0.5
            },
            scrollPaddingFix: { padding: "1px" },
            propertiesCategoriesList: [],
            styleAdd: null
        };
    },
    computed: {
        ...mapState("userProfile", ["userData"]),
        ...mapState("components", ["properties", "components", "bodyReference", "activeComponent",
            "componentsPropertiesCategories", "collapseHistory", "data", "fileNameWithDataModel", "filenameChange"]),
        isSlot() {
            return this.activeProperties && this.activeProperties.__component === "ctrl-slot";
        },
        activeProperties() {
            return this.activeComponent ? this.properties[this.activeComponent] : null;
        },
        slots() {
            const slotObject = [];
            if (this.activeComponent && this.bodyReference.hasOwnProperty(this.activeComponent)) {
                const slots = this.bodyReference[this.activeComponent];
                slots.forEach(slot => {
                    slotObject[slot.guid] = this.properties[slot.guid];
                });
            }

            return slotObject;
        }
    },
    watch: {
        activeComponent: {
            handler(val) {
                if (val) {
                    this.setFileNameWithDataModel(this.activeProperties.fileName);
                    if (this.componentsPropertiesCategories.hasOwnProperty(this.properties[val].__component)) {
                        const propertiesCategoriesList = [...this.componentsPropertiesCategories[this.properties[val].__component]];
                        const index = propertiesCategoriesList.findIndex(element => element.label === "Styles");

                        if (index === -1) {
                            this.styleAdd = null;
                        } else {
                            const styleInfo = propertiesCategoriesList.splice(index, 1);
                            this.styleAdd = styleInfo[0].name;
                        }

                        this.propertiesCategoriesList = propertiesCategoriesList;
                    } else {
                        this.styleAdd = null;
                        this.propertiesCategoriesList = [];
                    }
                }
            },
            immediate: true
        },
        fileNameWithDataModel: {
            handler(val) {
                if (val) {
                    this.activeProperties.fileName = this.fileNameWithDataModel;
                }
            },
            immediate: true
        },
        filenameChange: {
            handler(val) {
                if (val) {
                    this.activeProperties.fileName = this.fileNameWithDataModel;
                }
            },
            immediate: true
        }

    },
    beforeDestroy() {
        this.clearCollapseHistory();
    },
    methods: {
        ...mapMutations("components", ["updateCollapseHistory", "clearCollapseHistory", "setFileNameWithDataModel"]),
        addSlot() {
            this.$emit("action", { action: "add-slot" });
        },
        updateCategory(name, value) {
            this.updateCollapseHistory({ name, value });
        },
        opened(name) {
            return this.collapseHistory.hasOwnProperty(name) ? this.collapseHistory[name] : false;
        }
    }
};
